export const flex = {display: "flex"}
export const fc = {...flex, flexDirection: "column"}
export const fr = {...flex, flexDirection: "row"}
export const fcenter = {...flex, alignItems: "center", justifyContent: "center"}
export const ffill = {...flex, alignItems: "stretch", justifyContent: "space-around"}
export const fullscreen = {height: "100vh", left: 0, position: "fixed", top: 0, width: "100vw", zIndex: 1}
export const colors = {
	orange: "#e31d48",
	purple: "#3c1d4a",
	white: "#fff",
}
export const rounded = {borderRadius: "1vw"}
export const bg = color => ({backgroundColor: color})
export const whitewash = {backgroundColor: "rgba(255, 255, 255, 0.4"}
export const pad = size => ({padding: size})
export const rel = {position: "relative"}
export const abs = {position: "absolute"}